// extracted by mini-css-extract-plugin
module.exports = {"home-page-container":"_home_home-page-container__3PIzX","description":"_home_description__vY38N"};